export default {
    // The blog's title as it appears in the layout header, and in the document
    // <title> tag.
    title: "addTvb-code-notes",

    author: "Abayev Arslan",
    description:
        "Небольшой блог с заметками в виде применимых на практике кусочков кода для разных нужд👨‍💻",

    // The number of posts to a page on the site index.
    indexPageSize: 10,
};
